import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import SwiperCore, { Navigation, A11y, Keyboard, Pagination } from 'swiper';
import { TMultiMedia } from 'news/utils/types';
import styles from './ImageSlider.module.scss';
import { LeftArrow, RightArrow, SmallArrowIcon } from 'app/assets/images/icons';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { useModal } from 'app/context/Modal';
import 'swiper/components/pagination/pagination.scss';
interface Props {
  imageUrls: TMultiMedia[];
  imageIndex?: number;
  compId?: string;
  isMiniSlider?: boolean;
  conversationsPopup?: boolean;
}
const ImageSlider: React.FC<Props> = ({
  imageUrls,
  imageIndex,
  compId = 'image',
  isMiniSlider,
  conversationsPopup,
}) => {
  SwiperCore.use([Navigation, A11y, Keyboard, Pagination]);
  const modal = useModal();
  const handelOpenInstaMultipleMedia = (index = 0) => {
    modal.show({
      instaMediaUrls: imageUrls,
      imageIndex: index,
    });
  };
  const [swiperInstance, setSwiperInstance] = useState(imageIndex);
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  return (
    <div id={`${compId}-swiperSlider`} className={styles.ImagesliderContainer}>
      {imageUrls.length !== 1 ? (
        <>
          <button
            id={'customswiperprevbutton'}
            className={`custom_next_${compId} ${styles.nextbutton} ${conversationsPopup ? styles.newButton : ''} ${isMiniSlider ? styles.miniSliderHover : ''}`}
            style={{
              opacity:
                imageUrls?.length - 1 === swiperInstance && !conversationsPopup
                  ? '0.4'
                  : imageUrls?.length - 1 === swiperInstance &&
                      conversationsPopup
                    ? '0'
                    : undefined,
              right: conversationsPopup ? '30px' : undefined,
            }}
            data-testid="imageSliderRightArrow"
          >
            {conversationsPopup ? (
              <SmallArrowIcon style={{ scale: '-1' }} />
            ) : (
              <RightArrow />
            )}
          </button>
          <button
            className={`custom_prev_${compId} ${styles.previosbutton} ${conversationsPopup ? styles.newButton : ''}${isMiniSlider ? styles.miniSliderHover : ''}`}
            style={{
              left: conversationsPopup ? '30px' : undefined,
              opacity:
                !swiperInstance && !conversationsPopup
                  ? '0.4'
                  : !swiperInstance && conversationsPopup
                    ? '0'
                    : undefined,
            }}
            data-testid="imageSliderLeftArrow"
          >
            {conversationsPopup ? <SmallArrowIcon /> : <LeftArrow />}
          </button>
        </>
      ) : (
        <></>
      )}
      {imageUrls?.length !== 0 && (
        <Swiper
          initialSlide={imageIndex || 0}
          spaceBetween={3}
          slidesPerView={1}
          onSlideChange={(swiper) => {
            setSwiperInstance(swiper?.activeIndex);
            videoRefs.current.forEach((video) => video?.pause());
          }}
          navigation={{
            nextEl: `.custom_next_${compId}`,
            prevEl: `.custom_prev_${compId}`,
          }}
          keyboard={true}
          data-testid="swiperElement"
          pagination={
            conversationsPopup
              ? {
                  clickable: true,
                }
              : false
          }
        >
          {imageUrls?.map((image: TMultiMedia, i) => (
            <SwiperSlide className={styles.swiper_slide} key={i}>
              {image?.type === 'video' ? (
                <iframe
                  src={image?.url || ''}
                  width="540"
                  height="310"
                  data-testid="single_video_test"
                ></iframe>
              ) : (image?.type === 'VIDEO' && isMiniSlider) ||
                (image?.type === 'IGTV' && isMiniSlider) ||
                (image?.type === 'REEL' && isMiniSlider) ? (
                <div className={styles.tweetImageUrl}>
                  <img
                    src={image?.thumbnail}
                    alt="image"
                    onClick={() => handelOpenInstaMultipleMedia(i)}
                  />
                  <div className={styles.VideoBtn}>
                    <PlayArrowIcon />
                  </div>
                </div>
              ) : (image?.type === 'VIDEO' && !isMiniSlider) ||
                (image?.type === 'IGTV' && !isMiniSlider) ||
                (image?.type === 'REEL' && !isMiniSlider) ? (
                <video
                  crossOrigin="anonymous"
                  width={conversationsPopup ? '447' : '740px'}
                  height={conversationsPopup ? '600px' : '510px'}
                  controls
                  ref={(el) => (videoRefs.current[i] = el)}
                >
                  <source src={image?.url} type="video/mp4"></source>
                </video>
              ) : (
                <img
                  data-testid="single_image_test"
                  src={image?.url || ''}
                  onClick={
                    isMiniSlider
                      ? () => handelOpenInstaMultipleMedia(i)
                      : undefined
                  }
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default ImageSlider;
